var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37695 9.51114C7.37695 9.12583 7.68931 8.81348 8.07463 8.81348H12.7258C13.1111 8.81348 13.4235 9.12583 13.4235 9.51114C13.4235 9.89644 13.1111 10.2088 12.7258 10.2088H8.07463C7.68931 10.2088 7.37695 9.89644 7.37695 9.51114Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4002 6.54395C10.7855 6.54395 11.0979 6.8563 11.0979 7.2416V11.8927C11.0979 12.278 10.7855 12.5903 10.4002 12.5903C10.0149 12.5903 9.70251 12.278 9.70251 11.8927V7.2416C9.70251 6.8563 10.0149 6.54395 10.4002 6.54395Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62793 5.05586C1.62793 2.69968 3.54842 0.767578 5.9163 0.767578H14.8837C17.2523 0.767578 19.1703 2.6996 19.1814 5.05257L19.1814 5.05586L19.1814 18.1625C19.1814 19.1567 18.8214 20.0362 18.0541 20.4881C17.2866 20.9401 16.3435 20.8278 15.4753 20.3445M15.4753 20.3445L10.9296 17.8202C10.8239 17.7602 10.637 17.7091 10.4082 17.7091C10.18 17.7091 9.98797 17.7599 9.87472 17.823L5.33409 20.3445L5.33189 20.3457C4.4628 20.8243 3.52084 20.932 2.75527 20.4811C1.98917 20.0299 1.62793 19.1539 1.62793 18.1625V5.05586M5.9163 2.1629C4.3214 2.1629 3.02328 3.46794 3.02328 5.05586V18.1625C3.02328 18.8456 3.26204 19.1602 3.46338 19.2788C3.66513 19.3976 4.0577 19.4541 4.65775 19.1241C4.65812 19.1239 4.65849 19.1237 4.65885 19.1235L9.19509 16.6044C9.19494 16.6045 9.19524 16.6043 9.19509 16.6044C9.56547 16.398 10.0062 16.3137 10.4082 16.3137C10.8084 16.3137 11.2478 16.3971 11.6159 16.6053L16.1527 19.1247C16.754 19.4596 17.1462 19.4034 17.346 19.2858C17.5461 19.1679 17.7861 18.8521 17.7861 18.1625V5.05772C17.7778 3.46723 16.4775 2.1629 14.8837 2.1629H5.9163Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddboard);
export default __webpack_public_path__ + "static/media/addboard.53daa139.svg";
export { ForwardRef as ReactComponent };